<template>
    <proveedor-form :idBusiness="idBusiness" :idProveedor="idProveedor" :pag="pag" :ultimaCategoria="ultimaCategoria"
                    :idSubproducto="idSubproducto" :desdeSubproducto="desdeSubproducto"></proveedor-form>
</template>

<script>
    import ProveedorForm from '../../../Widgets/Proveedores/ProveedorForm.vue'
    import swal from 'sweetalert2'
    export default {

        components: {
            ProveedorForm
        },
        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                idProveedor: this.$route.params.idProveedor,
                pag: this.$route.params.pag,
                ultimaCategoria: this.$route.params.ultimaCategoria,
                desdeSubproducto: this.$route.params.desdeSubproducto,
                idSubproducto: this.$route.params.idSubproducto
            }

        },
        created() {
            let action = this.idProveedor ? this.$i18n.t("editar") : this.$i18n.t("nuevo");
            this.$store.dispatch('setNameRoute', action +' ' +this.$i18n.t("proveedor"));

            this.getRestrictions();

        },

        methods: {

            getRestrictions() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness,
                        idRestriction: 10,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getRestrictionsByTipo", config)
                    .then(function (response) {

                        if (!response.data.response) {

                            swal({
                                title: this.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.$router.push({
                                name: 'configuracion'
                            })


                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            }


        }


    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Proveedores/Proveedor.vue